import { s3KeyToUrl } from 'utils/images';
import fetchAPI from 'utils/fetchAPI';

export const COMPANY_IMAGE = 'company';
export const CHANNEL_IMAGE = 'company-channel';
export const BROADCAST_IMAGE = 'message';

export const getRealMIMEType = (file, callback) => {
  const fileReader = new FileReader();
  fileReader.onload = evt => {
    const header = new Uint8Array(evt.target.result)
      .subarray(0, 4)
      .reduce((x, y) => x.toString(16) + y.toString(16), '');
    let type;
    // Check the file signature against known types
    switch (header) {
      case '89504e47':
        type = 'image/png';
        break;
      case '47494638':
        type = 'image/gif';
        break;
      case 'ffd8ffe0':
      case 'ffd8ffe1':
      case 'ffd8ffe2':
        type = 'image/jpeg';
        break;
      case '25504446':
        type = 'application/pdf';
        break;
      default:
        type = ''; // Or you can use the file.type as fallback
        break;
    }
    callback(type);
  };
  fileReader.readAsArrayBuffer(file);
};

export const uploadImage = ({ imageData, type, token }) =>
  new Promise((resolve, reject) => {
    const data = new FormData();
    data.append('image', imageData);
    data.append('type', type);

    fetchAPI({
      endpoint: '/images',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    })
      .then(res => {
        if (res.status !== 200) {
          return reject('INVALID_FILE');
        }
        return res.json();
      })
      .then(json => resolve(json.data.image_key));
  });

export const MESSAGE = 'message';
export const NEWSFEED = 'newsfeed';
export const CHANNEL_FILE = 'company-channel';

export const uploadFile = ({ fileData, type, token }) =>
  new Promise((resolve, reject) => {
    const data = new FormData();
    data.append('file', fileData);
    data.append('type', type);

    fetchAPI({
      endpoint: '/upload_file',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    }).then(res => {
      if (res.status === 413) {
        return reject(res.statusText);
      } else if (res.status !== 200) {
        return reject('INVALID_FILE');
      }
      return res.json().then(json => resolve(json.data.url)); // { file_key, url }
    });
  });



// WEBPACK FOOTER //
// ./app/actions/FileUploadActionCreators.js